<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="row bg-white mb-4">
        <div
          class="col-xl-1 col-lg-2 col-md-3 col-sm-4 col-12 d-flex align-items-center justify-content-center"
        >
          <v-btn class="btn-return" @click="handleBack"
            ><i class="fas fa-arrow-left mr-2 text-twenty"></i> VOLTAR</v-btn
          >
        </div>
        <div class="col-xl-10 col-lg-8 col-md-6 col-sm-4 col-12">
          <div>
            <h6 class="upper-text mb-0">FORMULÁRIO: {{ form.name }}</h6>
            <h6 class="upper-text worksansr text-fourteen m-0">
              DESCRIÇÃO: {{ form.description }}
            </h6>
            <h6 class="upper-text worksansr text-fourteen m-0">
              STATUS: {{ form.status }}
            </h6>
            <h6 class="worksansr">
              Respondido por
              {{
                professionalClassCouncilValue({
                  id: form.user_professional_class_council_id,
                  name: form.user_name,
                  profile: form.user_profile_name,
                  cpf: form.user_cpf,
                  office: form.user_office,
                  value: form.user_professional_class_council_value,
                })
              }}
              - Aberto no dia
              {{ formatDate(form.created_at)
              }}<span v-if="form.updated_at"
                >, finalizado no dia {{ formatDate(form.updated_at) }}.
              </span>
            </h6>
          </div>
        </div>
        <div
          class="col-xl-1 col-lg-2 col-md-3 col-sm-4 col-12 d-flex align-items-center justify-content-center"
        >
          <v-btn class="btn-return" @click="handleToPrint"
            ><i class="fas fa-print mr-2 text-twenty"></i>IMPRIMIR</v-btn
          >
        </div>
        <div class="col-md-12 pt-0">
          <div class="v-warning p-2">
            Só pode realizar alterações até 14 horas depois da data que foi
            aberto o formulário!
          </div>
        </div>
      </div>
      <Attachments
        :semiology_form_question_answer_id="
          form.semiology_form_question_answer_id
        "
      />
      <v-expansion-panels accordion mandatory v-model="current_panel">
        <v-expansion-panel v-for="category in categories" :key="category.id">
          <v-expansion-panel-header class="back-ground-grey2">
            <h6 class="mb-0 upper-text">
              <span class="worksansr">CATEGORIA:</span> {{ category.name }}
              <br />
              <span class="worksansr text-thirteen"
                >({{ category.questions.length }}
                {{
                  category.questions.length > 1 ? "perguntas" : "pergunta"
                }})</span
              >
            </h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              class="row"
              v-for="(question, question_index) in category.questions"
              :key="question.id"
            >
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h6>
                  {{ question_index + 1 }}. {{ question.statement }}
                  <span class="mandatory-data worksansr">
                    {{ question.mandatory == 1 ? "(Obrigatório)" : "" }}</span
                  >
                </h6>
                <Open
                  v-if="question.semiology_form_question_type_value == 'OPEN'"
                  :form="form"
                  :question="question"
                  :category_id="category.id"
                  v-on:answer="handleChangeAnswerQuestions"
                />
                <Rating
                  v-if="question.semiology_form_question_type_value == 'RATING'"
                  :form="form"
                  :category_id="category.id"
                  :question="question"
                  v-on:answer="handleChangeAnswerQuestions"
                />
                <SingleChoice
                  v-if="
                    question.semiology_form_question_type_value ==
                    'SINGLE_CHOICE'
                  "
                  :form="form"
                  :category_id="category.id"
                  :question="question"
                  v-on:answer="handleChangeAnswerQuestions"
                />
                <MultipleChoice
                  v-if="
                    question.semiology_form_question_type_value ==
                    'MULTIPLE_CHOICE'
                  "
                  :form="form"
                  :category_id="category.id"
                  :question="question"
                  v-on:answer="handleChangeAnswerQuestions"
                />
                <Dichotomous
                  v-if="
                    question.semiology_form_question_type_value == 'DICHOTOMOUS'
                  "
                  :form="form"
                  :category_id="category.id"
                  :question="question"
                  v-on:answer="handleChangeAnswerQuestions"
                />
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="text-right">
        <v-btn
          v-if="form.status == 'PENDENTE'"
          @click="answerQuestions"
          :disabled="loading"
          class="btn-save"
        >
          <i class="fas fa-save mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}</v-btn
        >
        <hr />
        <p class="worksansr m-0">
          Para finalizar o formulário, responda as questões, clique em SALVAR
          para depois finalizar.
        </p>
        <confirmation-dialog
          class="ml-2"
          v-if="semiology_form_question_answer.status == 'PENDENTE'"
          message-title="CONFIRMAÇÃO"
          message-body="TEM CERTEZA QUE DESEJA EXCLUIR O FORMULÁRIO?"
          open-class="btn-delete"
          open-text="EXCLUIR FORMULÁRIO"
          openLeftIcon="fa-times"
          @yes="deleteSemiologyAnswer"
        />
        <confirmation-dialog
          class="ml-2"
          v-if="semiology_form_question_answer.status == 'PENDENTE'"
          message-title="CONFIRMAÇÃO"
          message-body="TEM CERTEZA QUE DESEJA FINALIZAR O FORMULÁRIO?"
          open-class="btn-save"
          open-text="FINALIZAR FORMULÁRIO"
          openLeftIcon="fa-check"
          @yes="finish"
        />
        <confirmation-dialog
          class="ml-2"
          v-if="
            permission('read', 'master_finish_semiology') &&
            form.user_id != user_id &&
            semiology_form_question_answer.status == 'PENDENTE'
          "
          message-title="CONFIRMAÇÃO"
          message-body="TEM CERTEZA QUE DESEJA FINALIZAR O FORMULÁRIO?"
          open-class="btn-save"
          open-text="FINALIZAR FORMULÁRIO COMO MASTER"
          openLeftIcon="fa-check"
          @yes="finishByMaster"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import ConfirmationDialog from "../../Components/ConfirmationDialog";

import toast from "../../../lib/ToastNotification";

import Open from "./Answered/Open";
import Rating from "./Answered/Rating";
import SingleChoice from "./Answered/SingleChoice";
import MultipleChoice from "./Answered/MultipleChoice";
import Dichotomous from "./Answered/Dichotomous";

import Attachments from "./Answered/Attachments";

import { professionalClassCouncilValue, formatDate } from "../../../lib/format";

import api from "../../../services/api";

import permission from "../../../lib/permission";

import { userData } from "../../../lib/functions";

import { digitalCertificate } from "../../../lib/digital-certificate";

export default {
  name: "AnsweredForm",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    Open,
    Rating,
    SingleChoice,
    MultipleChoice,
    Dichotomous,
    Attachments,
  },

  props: {
    resident_id: [String, Number],
    form: Object,
  },

  data() {
    return {
      user_id: null,

      current_panel: 0,
      categories: [],

      MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
      DICHOTOMOUS: "DICHOTOMOUS",
      SINGLE_CHOICE: "SINGLE_CHOICE",
      RATING: "RATING",
      OPEN: "OPEN",

      answer: [],
      semiology_form_question_answer: {},
      allAnswered: true,

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    professionalClassCouncilValue,
    permission,

    handleToPrint() {
      let {
        resident_id,
        form: { semiology_form_id, semiology_form_question_answer_id },
      } = this;

      let route = this.$router.resolve({
        name: "print-semiology",
        params: {
          resident_id,
          semiology_form_id,
          semiology_form_question_answer_id,
        },
      });

      window.open(route.href, "_blank");
    },

    handleBack() {
      this.$emit("clickRowTable");
    },

    async retrieve() {
      this.user_id = userData().user.id;

      await this.get();
    },

    async get() {
      try {
        this.loading = true;

        let {
          form: { semiology_form_id, semiology_form_question_answer_id },
        } = this;

        let params = { semiology_form_id, semiology_form_question_answer_id };

        let response = await api.get(
          "/rest-home/answer-semiology/answered-form",
          {
            params,
          }
        );

        let {
          error,
          errors,
          categories,
          allAnswered,
          semiology_form_question_answer,
        } = response.data;
        if (!error) {
          this.categories = categories;
          this.allAnswered = allAnswered;
          this.semiology_form_question_answer = semiology_form_question_answer;
          this.form.updated_at = semiology_form_question_answer.updated_at;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleChangeAnswerQuestions(e) {
      let { categories } = this;

      for (let category of categories) {
        if (category.id == e.category_id) {
          for (let question of category.questions) {
            if (question.id == e.id) {
              question.answer = e.answer;
              question.text = e.text;
            }
          }
        }
      }

      this.answer = categories;
    },

    async answerQuestions() {
      try {
        this.loading = true;

        const { resident_id, form, answer } = this;

        let answerFormated = [];

        for (let category of answer) {
          let questions = [];
          for (let question of category.questions) {
            if (
              question.semiology_form_question_type_value == "MULTIPLE_CHOICE"
            ) {
              if (
                question.answer &&
                question.answer != undefined &&
                typeof question.answer == "object" &&
                question.answer.length > 0
              ) {
                let is = [];
                for (let i of question.answer) {
                  is.push({ id: i.id, checked: i.checked });
                }
                question.answer = is;
              }
            }

            questions.push({
              semiology_form_question_type_value:
                question.semiology_form_question_type_value,
              answer: question.answer,
              text: question.text,
              id: question.id,
              answered: question.answered,
              mandatory: question.mandatory,
            });
          }
          answerFormated.push({
            questions,
          });
        }

        let params = {
          resident_id,
          form: {
            semiology_form_question_answer_id:
              form.semiology_form_question_answer_id,
            user_id: form.user_id,
          },
          answer: answerFormated,
        };
        const response = await api.put(
          "/rest-home/answer-semiology/form",
          params
        );
        const { error, errors, message } = response.data;
        if (!error) {
          toast(message, "success");
          this.errors = [];
          this.get();
          this.answer = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async finishByMaster() {
      try {
        this.loading = true;

        const { resident_id, form, answer } = this;

        let params = {
          resident_id,
          form,
          answer,
        };
        const response = await api.post(
          "/rest-home/answer-semiology/form-finish-master",
          params
        );
        const { error, errors, message } = response.data;
        if (!error) {
          toast(message, "success");
          this.errors = [];
          this.get();
          this.$emit("update");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async finish() {
      try {
        this.loading = true;

        const { resident_id, form, answer } = this;

        let params = {
          resident_id,
          form,
          answer,
        };
        const response = await api.post(
          "/rest-home/answer-semiology/form-finish",
          params
        );
        const { error, errors, message, item } = response.data;
        if (!error) {
          toast(message, "success");
          this.errors = [];
          this.get();
          this.$emit("update");
          this.executeCertificate(item);
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteSemiologyAnswer() {
      try {
        this.loading = true;

        const { resident_id, form } = this;

        let data = { resident_id, form };

        const response = await api.delete(
          "/rest-home/answer-semiology/form-delete",
          { data }
        );

        const { error, errors, message } = response.data;
        if (!error) {
          toast(message, "success");
          this.errors = [];
          this.$emit("delete");
          this.handleBack();
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async executeCertificate(item) {
      if (!item) {
        return;
      }

      let data = [];

      let { categories } = item;

      for (let category of categories) {
        data.push({
          col1: {
            exist: true,
            text: `CATEGORIA: ${category.name} (${category.questions.length} ${
              category.questions.length > 1 ? "perguntas" : "pergunta"
            })`,
          },
          col2: {
            exist: false,
            text: "",
          },
          col3: {
            exist: false,
            text: "",
          },
          col4: {
            exist: false,
            text: "",
          },
        });

        let question_index = 0;
        for (let question of category.questions) {
          let { semiology_form_question_type_value } = question;

          let text_response = "";

          if (semiology_form_question_type_value == "OPEN") {
            text_response = `${
              question.alternatives[0].text
                ? question.alternatives[0].text
                : "Não foi respondido!"
            }`;
          } else if (semiology_form_question_type_value == "RATING") {
            let alternative_index = 0;
            for (let alternative of question.alternatives) {
              if (alternative.answer) {
                text_response += `${alternative_index + 1} ${
                  alternative.label
                }; `;
              }
            }
          } else if (
            semiology_form_question_type_value == "SINGLE_CHOICE" ||
            semiology_form_question_type_value == "MULTIPLE_CHOICE" ||
            semiology_form_question_type_value == "DICHOTOMOUS"
          ) {
            for (let alternative of question.alternatives) {
              if (alternative.answer) {
                text_response += `${alternative.label}; `;
              }
            }
          }

          data.push({
            col1: {
              exist: true,
              text: `${question_index + 1}. ${question.statement} ${
                question.mandatory == 1 ? "(Obrigatório)" : ""
              }`,
            },
            col2: {
              exist: true,
              text: text_response,
            },
            col3: {
              exist: false,
              text: "",
            },
            col4: {
              exist: false,
              text: "",
            },
          });

          question_index++;
        }
      }

      let obj = {
        title: `FORMULÁRIO - ${item.semiology_form.name} DESCRIÇÃO: ${item.semiology_form.description}`,
        data,
        exist_footer: false,
        item,
        created_at: item.table.created_at,
        signature: true,
      };

      await digitalCertificate(obj);
    },
  },
};
</script>
